// Angular Files
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

// Angular Material Files
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

// Other External Files
import { EllipsisModule } from 'ngx-ellipsis';

// Teller Online Component Files
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { CartComponent } from './components/cart/cart.component';

// Teller Online Files
import { SharedModule } from 'apps/public-portal/src/app/shared/shared.module';
import { CartService } from './services/cart.service';
import { ReceiptService } from './services/receipt.service';

// Teller Online Library Files
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';
import { TellerOnlineSharedModule } from 'teller-online-libraries/shared';
import { HelpServiceBase } from 'teller-online-libraries/help';
import { HelpService } from 'apps/public-portal/src/app/shared/services';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        EllipsisModule,
        TellerOnlineSharedModule,
        TellerOnlineIconsModule,
        FormsModule,
        //Angular Material
        MatToolbarModule,
        MatIconModule,
        MatLegacyMenuModule,
        MatLegacyButtonModule,
        MatLegacyListModule,
        MatExpansionModule,
        MatLegacyFormFieldModule,
        MatLegacyInputModule,
        MatLegacyTooltipModule,
        MatLegacyDialogModule,
        MatLegacyProgressSpinnerModule,
        A11yModule
    ],
    declarations: [
        HeaderComponent,
        FooterComponent,
        MobileMenuComponent,
        CartComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        MobileMenuComponent,
        CartComponent
    ],
    providers: [
        CartService,
        ReceiptService,
        { provide: HelpServiceBase, useExisting: HelpService }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
 }
